import React, { useState } from 'react';
import {
  formatDateTimeNoSeconds,
  formatDurationHoursMinutes,
  formatVisibilityScope,
  shortenMessage,
  durationPartsFromTarget
} from '../../utils/rescuePush/constants';

function DurationEditor({ item, onSave, onCancel }) {
  const initial = durationPartsFromTarget(item);
  const [hours, setHours] = useState(String(initial.hours));
  const [minutes, setMinutes] = useState(String(initial.minutes));

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        minWidth: 120
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
        <input
          type="number"
          min="0"
          value={hours}
          onChange={(e) => setHours(e.target.value)}
          style={{ width: 48, padding: '2px 4px' }}
          title="小时"
        />
        <span>时</span>
        <input
          type="number"
          min="0"
          max="59"
          value={minutes}
          onChange={(e) => setMinutes(e.target.value)}
          style={{ width: 48, padding: '2px 4px' }}
          title="分钟"
        />
        <span>分</span>
      </div>
      <div style={{ display: 'flex', gap: 4 }}>
        <button
          type="button"
          onClick={() => onSave(Number(hours) || 0, Number(minutes) || 0)}
          style={{
            padding: '2px 6px',
            fontSize: 12,
            background: '#1976d2',
            color: '#fff',
            border: 'none',
            borderRadius: 3,
            cursor: 'pointer'
          }}
        >
          保存
        </button>
        <button
          type="button"
          onClick={onCancel}
          style={{
            padding: '2px 6px',
            fontSize: 12,
            background: '#eee',
            border: '1px solid #ccc',
            borderRadius: 3,
            cursor: 'pointer'
          }}
        >
          取消
        </button>
      </div>
    </div>
  );
}

/**
 * 历史管理面板
 */
export default function HistoryPanel({
  historyTab,
  setHistoryTab,
  historyLoading,
  targetHistory,
  trackHistory,
  handleHistoryItemClick,
  canDeleteHistoryItem,
  handleDelete,
  handleToggleFinished,
  handleUpdateTargetDuration
}) {
  const [editingDurationId, setEditingDurationId] = useState(null);

  const messageTitle = (item) => {
    const full = item.message || '无消息';
    const scope = formatVisibilityScope(item);
    return `${full}\n可见范围：${scope}`;
  };

  return (
    <>
      <div style={{ marginBottom: 16 }}>
        <button
          onClick={() => setHistoryTab('target')}
          style={{
            marginRight: 10,
            padding: '6px 18px',
            background: historyTab === 'target' ? '#1976d2' : '#f5f5f5',
            color: historyTab === 'target' ? '#fff' : '#333',
            border: '1px solid #ddd',
            borderRadius: 4
          }}
        >
          目标历史
        </button>
        <button
          onClick={() => setHistoryTab('track')}
          style={{
            padding: '6px 18px',
            background: historyTab === 'track' ? '#1976d2' : '#f5f5f5',
            color: historyTab === 'track' ? '#fff' : '#333',
            border: '1px solid #ddd',
            borderRadius: 4
          }}
        >
          轨迹历史
        </button>
      </div>
      {historyLoading ? (
        <div>加载中...</div>
      ) : historyTab === 'target' ? (
        <div style={{ maxHeight: 560, overflow: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px', tableLayout: 'fixed' }}>
              <thead>
                <tr style={{ background: '#f5f5f5', position: 'sticky', top: 0, zIndex: 1 }}>
                  <th style={{ padding: '6px 4px', border: '1px solid #ddd', textAlign: 'left', width: '18%' }}>时间</th>
                  <th style={{ padding: '6px 4px', border: '1px solid #ddd', textAlign: 'left', width: '16%' }}>有效时长</th>
                  <th style={{ padding: '6px 4px', border: '1px solid #ddd', textAlign: 'left', width: '22%' }}>消息</th>
                  <th style={{ padding: '6px 4px', border: '1px solid #ddd', textAlign: 'left', width: '10%' }}>组</th>
                  <th style={{ padding: '6px 4px', border: '1px solid #ddd', textAlign: 'left', width: '12%' }}>姓名</th>
                  <th style={{ padding: '6px 4px', border: '1px solid #ddd', textAlign: 'left', width: '10%' }}>操作员</th>
                  <th style={{ padding: '6px 4px', border: '1px solid #ddd', textAlign: 'left', width: '7%' }}>操作</th>
                  <th style={{ padding: '6px 4px', border: '1px solid #ddd', textAlign: 'center', width: '5%', whiteSpace: 'nowrap' }}>完结</th>
                </tr>
              </thead>
              <tbody>
                {targetHistory.length === 0 ? (
                  <tr>
                    <td colSpan={8} style={{ color: '#888', padding: 16, textAlign: 'center', border: '1px solid #ddd' }}>
                      暂无历史记录
                    </td>
                  </tr>
                ) : (
                  targetHistory.map((item) => {
                  const expired = item.expires_at && new Date(item.expires_at).getTime() <= Date.now();
                  const finished = item.status === '已完结' || expired;
                  return (
                    <tr key={item.id} style={{ borderBottom: '1px solid #eee', opacity: finished ? 0.65 : 1 }}>
                      <td
                        style={{
                          padding: '6px 4px',
                          cursor: 'pointer',
                          color: '#1976d2',
                          textDecoration: 'underline',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis'
                        }}
                        onClick={() => handleHistoryItemClick('target', item)}
                        title="点击在右侧地图显示点位"
                      >
                        {formatDateTimeNoSeconds(item.created_at)}
                      </td>
                      <td
                        style={{
                          padding: '6px 4px',
                          whiteSpace: 'nowrap',
                          color: expired ? '#c62828' : undefined,
                          cursor: 'pointer'
                        }}
                        title={item.expires_at ? `截止：${formatDateTimeNoSeconds(item.expires_at)}（点击修改时长）` : '点击设置有效时长'}
                        onClick={() => setEditingDurationId(item.id)}
                      >
                        {editingDurationId === item.id ? (
                          <DurationEditor
                            item={item}
                            onCancel={() => setEditingDurationId(null)}
                            onSave={async (h, m) => {
                              if (typeof handleUpdateTargetDuration === 'function') {
                                const ok = await handleUpdateTargetDuration(item, h, m);
                                if (ok !== false) setEditingDurationId(null);
                              } else {
                                setEditingDurationId(null);
                              }
                            }}
                          />
                        ) : (
                          formatDurationHoursMinutes(item.created_at, item.expires_at)
                        )}
                      </td>
                      <td
                        style={{
                          padding: '6px 4px',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          cursor: 'pointer',
                          color: '#1976d2'
                        }}
                        title={messageTitle(item)}
                        onClick={() => handleHistoryItemClick('target', item)}
                      >
                        {shortenMessage(item.message, 18)}
                      </td>
                      <td style={{ padding: '6px 4px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={item.group_name || ''}>
                        {item.group_name}
                      </td>
                      <td style={{ padding: '6px 4px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={item.user_name || ''}>
                        {item.user_name}
                      </td>
                      <td style={{ padding: '6px 4px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={item.operator_name || '系统管理员'}>
                        {item.operator_name || '系统管理员'}
                      </td>
                      <td style={{ padding: '6px 4px' }}>
                        {canDeleteHistoryItem(item) ? (
                          <button
                            onClick={() => handleDelete('target', item.id)}
                            style={{
                              padding: '3px 6px',
                              background: '#f44336',
                              color: '#fff',
                              border: 'none',
                              borderRadius: 3,
                              cursor: 'pointer',
                              fontSize: '12px'
                            }}
                          >
                            删除
                          </button>
                        ) : (
                          <span style={{ color: '#999', fontSize: 12 }}>无权限</span>
                        )}
                      </td>
                      <td style={{ padding: '6px 4px', textAlign: 'center' }}>
                        <input
                          type="checkbox"
                          checked={item.status === '已完结'}
                          onChange={(e) => handleToggleFinished('target', item, e.target.checked)}
                          title={item.status === '已完结' ? '取消完结后会重新显示在指挥系统' : '完结后不再显示在指挥系统'}
                        />
                      </td>
                    </tr>
                  );
                })
                )}
              </tbody>
            </table>
        </div>
      ) : (
        <div style={{ maxHeight: 560, overflow: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px', tableLayout: 'fixed' }}>
              <thead>
                <tr style={{ background: '#f5f5f5', position: 'sticky', top: 0, zIndex: 1 }}>
                  <th style={{ padding: '6px 4px', border: '1px solid #ddd', textAlign: 'left', width: '20%' }}>时间</th>
                  <th style={{ padding: '6px 4px', border: '1px solid #ddd', textAlign: 'left', width: '28%' }}>消息</th>
                  <th style={{ padding: '6px 4px', border: '1px solid #ddd', textAlign: 'left', width: '12%' }}>组</th>
                  <th style={{ padding: '6px 4px', border: '1px solid #ddd', textAlign: 'left', width: '14%' }}>姓名</th>
                  <th style={{ padding: '6px 4px', border: '1px solid #ddd', textAlign: 'left', width: '14%' }}>操作人员</th>
                  <th style={{ padding: '6px 4px', border: '1px solid #ddd', textAlign: 'left', width: '7%' }}>操作</th>
                  <th style={{ padding: '6px 4px', border: '1px solid #ddd', textAlign: 'center', width: '5%', whiteSpace: 'nowrap' }}>完结</th>
                </tr>
              </thead>
              <tbody>
                {trackHistory.length === 0 ? (
                  <tr>
                    <td colSpan={7} style={{ color: '#888', padding: 16, textAlign: 'center', border: '1px solid #ddd' }}>
                      暂无历史记录
                    </td>
                  </tr>
                ) : (
                  trackHistory.map((item) => (
                  <tr key={item.id} style={{ borderBottom: '1px solid #eee', opacity: item.status === '已完结' ? 0.65 : 1 }}>
                    <td
                      style={{
                        padding: '6px 4px',
                        cursor: 'pointer',
                        color: '#1976d2',
                        textDecoration: 'underline',
                        whiteSpace: 'nowrap'
                      }}
                      onClick={() => handleHistoryItemClick('track', item)}
                      title="点击飞行到该记录位置"
                    >
                      {formatDateTimeNoSeconds(item.created_at)}
                    </td>
                    <td
                      style={{
                        padding: '6px 4px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                      }}
                      title={item.message || '无消息'}
                    >
                      {shortenMessage(item.message, 20)}
                    </td>
                    <td style={{ padding: '6px 4px' }}>{item.group_name}</td>
                    <td style={{ padding: '6px 4px' }}>{item.user_name}</td>
                    <td style={{ padding: '6px 4px' }}>{item.operator_name || '系统管理员'}</td>
                    <td style={{ padding: '6px 4px' }}>
                      {canDeleteHistoryItem(item) ? (
                        <button
                          onClick={() => handleDelete('track', item.id)}
                          style={{
                            padding: '3px 6px',
                            background: '#f44336',
                            color: '#fff',
                            border: 'none',
                            borderRadius: 3,
                            cursor: 'pointer',
                            fontSize: '12px'
                          }}
                        >
                          删除
                        </button>
                      ) : (
                        <span style={{ color: '#999', fontSize: 12 }}>无权限</span>
                      )}
                    </td>
                    <td style={{ padding: '6px 4px', textAlign: 'center' }}>
                      <input
                        type="checkbox"
                        checked={item.status === '已完结'}
                        onChange={(e) => handleToggleFinished('track', item, e.target.checked)}
                        title={item.status === '已完结' ? '取消完结后会重新显示在指挥系统' : '完结后不再显示在指挥系统'}
                      />
                    </td>
                  </tr>
                ))
                )}
              </tbody>
            </table>
        </div>
      )}
    </>
  );
}
